































import Vue from 'vue';
import MpGroupField from './MpGroupField.vue';
import { TraceDays, TraceFilter, traceFilter } from '../../../customer/models/CustomerFilter';
import customerVuex from '../../../customer/vuex/common';

const trace: TraceFilter = traceFilter;

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    MpGroupField,
  },
  data() {
    return {
      trace,
      TraceDays,
      day: -1,
    };
  },
  methods: {
    updateCompare(value: number) {
      const v = this.customerFilter.trace;
      v.compare = value ;
      this.updateTrace(v);
    },
    updateCount(value: number) {
      const v = this.customerFilter.trace;
      v.count = value;
      this.updateTrace(v);
    },
    updateTrace(v: TraceFilter) {
      return this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'trace',
        value: v,
      });
    },
  },
});
